import React from "react";

/**
 * Centered empty state when the action-items list has no rows (filters, search, or caught up).
 *
 * @example
 * <ActionItemsListEmptyState
 *   title="You're all caught up"
 *   subtitle="New items will appear here when they're ready."
 * />
 */
const ActionItemsListEmptyState = ({
  title,
  subtitle = "",
  variant = "web",
  hint = "",
}) => {
  const message = String(title || "").trim();
  if (!message) return null;

  return (
    <div
      className={[
        "action-items-list-empty",
        variant === "extension" ? "action-items-list-empty--extension" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <p className="action-items-list-empty__title">{message}</p>
      {subtitle ? <p className="action-items-list-empty__subtitle">{subtitle}</p> : null}
      {hint ? <p className="action-items-list-empty__hint">{hint}</p> : null}
    </div>
  );
};

export default ActionItemsListEmptyState;
